import select2 from 'select2';

$(function () {
    initSelect2();
})

function initSelect2() {
    var selectElement = $('select');

    selectElement.each(function () {
        var $element = $(this),
            $elementName = $element.attr('name'),
            $placeholder = '';

        // if ($elementName == 'how-did-you-hear') {
        //     $placeholder = 'how did you hear about moove?';
        // }

        $element.select2({
            // placeholder: $placeholder,
            maximumSelectionLength: -1,
            minimumResultsForSearch: -1,
            dropdownParent: $('.select-wrap'),
            dropdownCssClass: "options-dropdown",
            width: '100%'
        });

        $element.next().addClass("select-" + $elementName);
    });

    $('.select-prefix').on('click', function () {
        selectElement.data('select2').toggleDropdown()
    })

    selectElement.on('select2:select', function (e) {
        var data = e.params.data;
        $(this).closest("form").submit();
    });

}
